declare namespace $ {

	type $shm_hitalama_guide_toggle__section_shm_hitalama_guide_page_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_page['help_section'] >
		,
		ReturnType< $shm_hitalama_guide_toggle['section'] >
	>
	export class $shm_hitalama_guide_page extends $mol_page {
		Help( ): $shm_hitalama_guide_toggle
		help_section( ): string
		head( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=page.view.tree.d.ts.map